import ReportsVue from '@/views/sa/reports/reports.vue';

const basePath = '/sa/reports';
const role = 'sa'; // 角色身份

export const SA_REPORTS_INDEX = 'sa-reports-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReportsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_REPORTS_INDEX,
      component: () => import(
        /* webpackChunkName: "reports" */
        `@/views/${role}/reports/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
